<template>
  <div class="block-two-page">
    <div class="block-two-content-one">
        <div class="left">
          <img class="icon" :src="require('../assets/icon/block-1Icon@2x.png')" alt="">
          <div class="number-box">
            <p class="title">目前区块号 current Blocks</p>
            <p class="number">
              {{blockNumber}}
            </p>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="right">
          <p class="list-item" v-for="(item, index) in blockDetail" :key="index">
            <span class="label">{{item.label}}</span>
            <span class="text">{{item.value}}</span>
          </p>
          <p class="list-item">
            <span class="label">交易次数</span>
            <span class="text">{{transList.length}}</span>
          </p>
        </div>
      </div>
      <div class="content-two">
        <el-table
          class="data-table"
          height="100%"
          :data="transList">
          <!-- <el-table-column
            width="100"
            prop="blockNumber_1"
            label="区块号">
          </el-table-column> -->
          <el-table-column
            width="150"
            prop="channelName"
            label="链名称">
          </el-table-column>
          <!-- <el-table-column
            width="100"
            prop="transactionIndex_1"
            label="数据ID">
          </el-table-column> -->
          <el-table-column
            prop="hash"
            label="数据Hash">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.hash }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.hash }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="from"
            label="发送方账户">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.from }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.from }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="input"
            label="接收方账户">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.to }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.to }}</div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>

<script>
export default {
  props: ['blockobj'],
  data() {
    return {
      transList: []
    }
  },
  components: {},
  computed: {
    blockNumber() {
      let res = ''
      if(this.blockobj) {
        res = this.blockobj['number']
      }
      return res
    },
    blockDetail() {
      let arry = [
        {
          label: '出块时间',
          key: 'createTime',
          value: ''
        },{
          label: '出块节点',
          key: 'parentHash',
          value: ''
        },{
          label: '块Hash值',
          key: 'hash',
          value: ''
        },
      ]

      arry.map(item => {
        item.value = this.blockobj[item.key]
      })
      return arry
    }
  },
  methods: {
    showBlock() {
      if(!this.blockobj) return
      this.blockDetail.map(item => {
        item.value = this.blockobj[item.key]
      })
    },
    fetchChannel () {
      return this.$http({
        id: 1,
        method: 'net_channelInfo'
      })
    },
    async fetchTrans(param) {
      let number = '0x' + parseInt(param).toString(16)
      let res = await this.$http({
        'id': 1,
        "params": [number, true],
        "method":"eth_getBlockByNumber"
      })
      if(res['transactions'] != null) {
        let dataList = res['transactions']
        dataList.map(item => {
          item.blockNumber_1 = this.blockNumber
          item.transactionIndex_1 = parseInt(item.transactionIndex, 16)
          item.channelName = '绿色电碳服务链'
        })
        this.transList = dataList
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/init-css.scss';

$area-radius: 25px;
$area-padding: .1rem;
$area-margin: .2rem;

.block-two-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  .block-two-content-one {
      height: 25%;
      margin: 40px 0;
      box-sizing: border-box;
      display: flex;

      .left {
        width: 50%;
        display: flex;
        align-items: center;
        padding-left: .6rem;
        .icon {
          height: 95%;
          max-height: 1.6rem;
        }
        .number-box {
          text-align: left;
          margin-left: .5rem;
          position: relative;
          top: -10px;
          .title {
            font-size: .15rem;
            position: relative;
            top: .3rem;
          }

          .number {
            font-size: .8rem;
            margin-top: 40px;
          }
        }
      }
      .vertical-line {
        height: 100%;
        width: 4px;
        border-radius: 1px;
        background: $font-color;
      }
      .right {
        display: flex;
        flex-direction: column;
        font-size: .16rem;
        text-align: left;
        padding-left:.2rem;
        width: 48%;
        justify-content: space-around;
        .list-item {
          display: flex;
          margin: .02rem 0;
          >span {
            display: inline-block;
          }

          .label {
            width: 1rem;
            text-align: right;
          }

          .text {
            margin-left: .2rem;
            width: 50%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  .content-two {
    background: #fff;
    flex: 1;
    border-radius: 10px;
  }
}

</style>
